enum UserType {
  OTHER = '0',
  PURCHASER = '1',
  AGENT = '2',
  SUPPLIER = '3',
  EXPERT_JUDGE = '4',
  REGULATOR = '5',
  PURCHASE_CENTER = '6',
  ESHOP = '7',
}

export default UserType;
export const UserTypeMap = {
  [UserType.AGENT]: '代理机构',
  [UserType.OTHER]: '其他',
  [UserType.PURCHASER]: '采购单位',
  [UserType.SUPPLIER]: '供应商',
  [UserType.EXPERT_JUDGE]: '评委',
  [UserType.PURCHASE_CENTER]: '采购中心',
  [UserType.REGULATOR]: '监管机构',
  [UserType.ESHOP]: '监管机构',
};
